import { render, staticRenderFns } from "./lowLitEconomy.vue?vue&type=template&id=53afafd4&scoped=true&"
import script from "./lowLitEconomy.vue?vue&type=script&lang=js&"
export * from "./lowLitEconomy.vue?vue&type=script&lang=js&"
import style0 from "./lowLitEconomy.vue?vue&type=style&index=0&id=53afafd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53afafd4",
  null
  
)

export default component.exports